export const SIDE_MENU_WIDTH = 232;
